(module =>{
    module.service('mktshSummaryCalculation', [mktshSummaryCalculation]);

    function mktshSummaryCalculation(this: $TSFixMe) {
        const service = this;

        function calculateMkshr (sumProductPM: $TSFixMe, sumMarket: $TSFixMe){
            return sumProductPM / sumMarket * 100;
        }

        service.calculateSumMktsh = (pmForecast: $TSFixMe, forecast: $TSFixMe) =>{
            var result= [];
            for(let i =0, max = pmForecast.length; i<max; i++){
                result.push(calculateMkshr(pmForecast[i], forecast[i]));
           }
           return result;
        };

    }

})(angular.module('topline.services'));